// Dependencies

import styled from 'styled-components';

export const WrapperDiv = styled.div`
  position: relative;
  z-index: 999999999;
`;
